import { createContext, useContext, useState } from "react";

import { useFloatingWindows } from "src/base-components/FloatingWindow/hooks";

type SelectedRows = Record<string, boolean>;
type OnSelectRowHandler = (
  updaterOrValue: SelectedRows | ((rows: SelectedRows) => SelectedRows),
) => void;

const CasesTableContext = createContext<{
  selectedRows: SelectedRows;
  onSelectRow: OnSelectRowHandler;
  isSelectionDisabled: boolean;
}>({
  selectedRows: {},
  onSelectRow: () => {},
  isSelectionDisabled: false,
});

export const CasesTableProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedRows, setSelectedRows] = useState<SelectedRows>({});
  const floatingWindows = useFloatingWindows();
  const isSelectionDisabled = Object.values(floatingWindows).some(
    (window) => window?.type === "cm-bulk-action",
  );

  return (
    <CasesTableContext.Provider
      value={{
        selectedRows,
        onSelectRow: setSelectedRows,
        isSelectionDisabled,
      }}
    >
      {children}
    </CasesTableContext.Provider>
  );
};

export const useCasesTableContext = () => {
  const context = useContext(CasesTableContext);

  if (!context) {
    throw new Error(
      "useCasesTableContext can only be called within CasesTableContext",
    );
  }

  return context;
};
